import React from 'react';

import { TitleTextField } from './style';

export function Title(props) {
  return <TitleTextField>{props.string}</TitleTextField>;
}
